var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"profile-page"},[_c('v-content',[_c('v-container',{attrs:{"fluid":"","fill-height":""}},[_c('h1',[_vm._v("Profile")])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }